import { useTypedQuery } from "hooks";
import { ChecklistsDashboardQueryKeys } from "modules/ChecklistsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Checklist, ChecklistID } from "models";

const sortQuestionGroups = (checklist: Checklist) => ({
  ...checklist,
  question_groups: checklist.question_groups
    ?.toSorted((a, b) => a.ordering - b.ordering)
    .map((questionGroup, groupIdx) => ({
      ...questionGroup,
      ordering: groupIdx,
      questions: questionGroup.questions?.toSorted((a, b) => a.ordering - b.ordering).map((question, questionIdx) => ({ ...question, ordering: questionIdx }))
    }))
});

export const useChecklistDetailsQuery = (id?: ChecklistID) =>
  useTypedQuery({
    queryKey: ChecklistsDashboardQueryKeys.checklistDetails(id),
    queryFn: async ({ endpoint, baseUrl, params }) => (await ApiInstance.post(endpoint, params, baseUrl)).data,
    select: sortQuestionGroups,
    enabled: !!id
  });
